import { reactive } from 'vue';

export const radiationTreatmentPlanningOptions = reactive([
    {
        name: "Level 3 - Complex Treatment Planning",
        count:0,
        applicable: true,
        ruleStament: 'Must include one or more of the following treatments:',
        conditions: [
            'All 5 and 6 field cases,',
            'All whole CNS cases,',
            '4-field conformal distribution,',
            '5 or 6-field non-conformal distribution,',
            '5 or 6-field conformal initial calculation,',
            '5 or 6-field non-conformal initial calculation,',
            '8-field distribution,',
            'All total/hemi-body planning,',
            'CT/MRI scan for treatment planning,',
            'Custom shielding (e.g. Cerrobend),',
            'Used manual or automatic compensators,',
            'Custom immobilization or device.',
        ],
        isSelected: false,
        code: 'X312',
        price: 680.45,
        displayRulesText: ' Show Rules:',
        showRules: false,
    }, {
        name: "Level 4 - Full 3D Treatment Preparation",
        count:0,
        applicable: true,
        ruleStament: `Radiation therapy must be oriented in two or more axes and must include one or more 
        of the following treatments:`,
        conditions: [`Full 3D target definition (volumetric imaging), 3D dose
            computation, 3D plan evaluation`,
            `Paediatric radiotherapy`,
            'Stereotactic radiotherapy',
            'Total skin electron treatment',
            'Total body irradiation',
            'Intensity Modulated Radiotherapy (IMRT)',
        ],
        isSelected: false,
        code: 'X313',
        price: 811.15,
        displayRulesText: ' Show Rules:',
        showRules: false,
    }
]); // end of rtpOptions list

export const teleradioOptions = reactive([
    {
        name: 'Teleradiotherapy',
        count:0,
        applicable: true,
        code: 'X302',
        conditions: [`X-ray, 150 KVP or higher, radium, cobalt, cesium betatron linear
                            accelerator.`],
        price: 15.90,
        isSelected: false,
    },
    {
        name: 'Minor teleradiotherapy',
        count:0,
        applicable: true,
        code: 'X304',
        conditions: [`X-ray, 150 KVP or less.`],
        price: 11.95,
        isSelected: false,
    },
])

export const intracavitaryTreatmentPlanning = reactive([
    {
        name: 'First Application',
        count:0,
        applicable: true,
        code: 'X305',
        price: 170.85,
        isSelected: false,
    },
    {
        name: 'Repeat Application',
        count:0,
        applicable: true,
        code: 'X306',
        price: 85.50,
        isSelected: false,
    },
])




export const isotopeOptions = reactive([
    {
        name: `Treatment planning, dosage calculation and preparation of any special treatment device`,
        count:0,
        isSelected: false,
        code: 'X322',
        price: 71.30,
    },
    {
        name: `First application`,
        count:0,
        isSelected: false,
        code: 'X323',
        price: 223.65,
    },

    {
        name: `Repeat Application`,
        count:0,
        isSelected: false,
        code: 'X334',
        price: 111.90,
    },
    {
        name: ` Interstitial application of radium or sealed radioisotope`,
        count:0,
        isSelected: false,
        code: 'X324',
        price: 223.65,
    },
    {
        name: `Application of radium or radioisotope plaque or mould`,
        count:0,
        isSelected: false,
        code: 'X325',
        price: 69.80,
    },
]);



/**
 * Utter filth of a function that updates xCode counters and isSelected on component initialization.
 * This is utterly fucking retarded for 2 reasons: 
 * 1 it modifies some global object in a nested function so will undoubtedly cause some nightmare to debug
 * 2 it is composed of 3 nested for loops
 * @param {Array<String>} codes 
 * @param {CodeObjects} masterList 
 */
export function updateXCodeObjects(codes, masterList){
  // forEach are no bueno with the continue statement due to scoping

  codeLoop: for (let c = 0; c < codes.length; c++){
    const code = codes[c];
  
    for (let m = 0; m < masterList.length; m++){
        for (let x = 0; x < masterList[m].length; x++){
            const xCode = masterList[m][x];
            if (code == xCode.code){
              xCode.count++;
              xCode.isSelected = true;
              continue codeLoop
            }
        } // masterList closing
    }
  
  } // codeLoop closing
}


/**
 * Converts master list to billable code objects
 * @returns {Object} code objects {name, price, code}
 */
export function getXCodeObjects(){
  const xCodeObjects = [];
  masterList.forEach(list => {
    list.forEach(codeObject =>{
      if (codeObject.count >= 1){
        for (let i = 0; i < codeObject.count; i++){
          xCodeObjects.push({
            name: codeObject.name,
            price: codeObject.price,
            code: codeObject.code
          })
        }
      }
    }
    )
  })
  return xCodeObjects;
}
/**
 * Clears all x codes and sets the count to 0 on master list
 */
export function clearXCodes(){
  masterList.forEach((list) => {
    list.forEach(codeObj => {
      codeObj.count = 0;
      codeObj.isSelected = false;
    })
  })
}
  
// this needs to be kept up to date as the vue relies on this declaration
export const masterList = [radiationTreatmentPlanningOptions, teleradioOptions, intracavitaryTreatmentPlanning, isotopeOptions];